import { OTHER } from 'constants/dateLimits';
import nameModelValidator from 'forms/shared/validators/models/name/name';
import { ValidateJSModel } from 'forms/shared/types';
import { isPVQForm } from 'helpers/form';
import { foreignBusinessAffairsFamilyOptions } from 'constants/enums/foreignBusinessOptions';
import pvqNameModelValidator from 'forms/shared/validators/models/pvqName/name';
import { ForeignBusinessFamilyItemModel } from '../types';

const foreignBusinessFamilyItemValidator: ValidateJSModel<ForeignBusinessFamilyItemModel> = {
  Name: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, model: { validator: pvqNameModelValidator } };
    }

    return { presence: true, model: { validator: nameModelValidator } };
  },

  Agency: { hasValue: true },

  Country: (value, attributes) => {
    if (attributes?.CountryFocused) {
      return {};
    }

    return { hasValue: true, country: { excludeUnitedStates: true } };
  },

  Date: { presence: true, date: OTHER },

  Circumstances: { hasValue: true },

  WhoWasAsked: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        hasValue: {
          validator: {
            inclusion: foreignBusinessAffairsFamilyOptions,
          },
        },
      };
    }

    return {};
  },

  FamilyName: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.WhoWasAsked?.value !== 'Myself') {
      return { presence: true, model: { validator: pvqNameModelValidator } };
    }

    return {};
  },
};

export default foreignBusinessFamilyItemValidator;
